import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import sessionReducer from "./sessionReducer";
import toastReducer from "./toastReducer";
import layoutReducer from "./layoutReducer";

const baseReducer = (history, reducers) => (state, action) => {
  const appReducer = combineReducers({
    router: connectRouter(history),
    session: sessionReducer,
    toast: toastReducer,
    layout: layoutReducer,
    ...reducers,
  });
  //action called to reset the redux state
  if (action.type === "session/clearState") {
    return appReducer(undefined, action);
  }

  return appReducer(state, action);
};

export default baseReducer;
